let lastSelectedIndex = 0;

export const getLastSelectedIndex = () => lastSelectedIndex;
export const setLastSelectedIndex = (val: number) => {
  lastSelectedIndex = val;
};
